"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var useEffect = React.useEffect;
var useKeyPress_1 = require("./useKeyPress");
var useKeyPressEvent = function (targetKey, onKeyup, onKeydown) {
    if (onKeyup === void 0) { onKeyup = undefined; }
    if (onKeydown === void 0) { onKeydown = undefined; }
    var useKeyboardJS = targetKey.length > 1;
    var pressedKeys = useKeyPress_1.default(targetKey, {
        useKeyboardJS: useKeyboardJS,
    });
    if (onKeydown === undefined) {
        onKeydown = onKeyup;
        onKeyup = null;
    }
    useEffect(function () {
        if (!pressedKeys) {
            if (onKeyup)
                onKeyup(targetKey);
            return;
        }
        if (onKeydown)
            onKeydown(targetKey);
    }, [pressedKeys]);
};
exports.default = useKeyPressEvent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/lib/useKeyPressEvent.js
// module id = 1208
// module chunks = 17